import RegistrarProfileScreen from './RegistrarProfileScreen';
export default RegistrarProfileScreen;
